import NoAccessOverlay from '@/creditflowresearch/ui/common/components/NoAccessOverlay';
import image from '@/creditflowresearch/ui/assets/noAccess/articleNoAccess.webp';
import {
  articleNoAccessTitle,
  articleImageCaption,
  articleNoAccessFeatures,
  articleNoAccessDescription,
} from './constants';

const NoAccessOverlayArticles = () => (
  <NoAccessOverlay
    title={ articleNoAccessTitle }
    features={ articleNoAccessFeatures }
    description={ articleNoAccessDescription }
    imageCaption={ articleImageCaption }
    image={ image.src }
  />
);

export default NoAccessOverlayArticles;
